var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerServiceImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 140,
    viewBox: "0 0 343 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.323 48.7988C185.38 49.7766 181.45 47.3707 180.477 43.4209L179.773 40.3717C178.801 36.4091 181.194 32.4593 185.124 31.4815C189.054 30.5037 192.997 32.9096 193.969 36.8594L194.75 39.9086C195.659 43.8069 193.265 47.821 189.323 48.7988Z",
    fill: "#FDC812"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.24 65.5572C160.24 65.5572 170.442 63.0869 182.18 67.4356C193.931 71.7842 200.383 73.2766 205.094 88.6512C209.804 104.026 213.158 120.635 213.158 120.635L233.55 129.526V138.738H201.407L193.791 124.276V139.78H143.466L133.64 82.437C133.704 82.437 135.573 67.6414 160.227 65.57L160.24 65.5572Z",
    fill: "#7EC0E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.048 134.056C160.048 134.056 170.045 133.863 172.503 134.056C174.961 134.249 180.183 136.655 181.412 138.855H160.24L160.048 134.056Z",
    fill: "#DFDFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.294 95.2656C150.294 95.2656 143.253 115.696 138.415 124.587L162.352 131.599L160.291 138.675H116.41C116.41 138.675 123.835 95.0855 134.549 79.7109C145.199 64.4007 157.974 80.2899 150.294 95.2785V95.2656Z",
    fill: "#7EC0E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.085 120.765L148.78 99.5107",
    stroke: "#1C5170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.013 124.439L197.606 106.39",
    stroke: "#1C5170"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.964 135.349C222.183 133.728 222.055 131.785 222.964 129.971L244.392 87.0251C245.429 84.9537 247.49 83.6543 249.743 83.6543H319.955C324.41 83.6543 327.38 88.3889 325.306 92.4159L303.877 135.362C302.905 137.305 300.908 138.604 298.783 138.668H190.872V135.297H222.951V135.362L222.964 135.349Z",
    fill: "#C6C6C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.888 45.7002L160.547 68.4597C159.612 74.8283 164.144 80.5921 170.071 80.5921C175.997 80.5921 180.529 74.8411 179.607 68.4855L176.305 45.7131H163.901L163.888 45.7002Z",
    fill: "#DFDFDF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.313 29.336C186.86 22.3314 180.035 17.8367 173.069 19.2968C166.103 20.7568 161.635 27.6188 163.088 34.6234L166.02 48.7547C167.474 55.7593 174.299 60.2541 181.265 58.794C188.23 57.334 192.699 50.472 191.246 43.4674L188.313 29.336Z",
    fill: "#DFDFDF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.633 25.7677C179.851 25.4304 182.146 25.5516 184.109 24.4607C190.469 20.8009 189.415 17.4021 189.531 14.1007C189.626 12.4276 187.386 11.5661 186.264 12.0456C179.959 14.9651 178.586 12.8704 172.263 12.2672C170.782 12.1566 169.33 11.9273 167.849 11.8167C164.295 11.4505 159.745 13.1027 156.72 14.9392C153.031 17.1789 151.245 20.8886 149.886 24.1373C147.372 30.308 148.866 38.5892 152.979 43.8666C156.228 48.0532 158.644 51.5337 162.826 52.9327C162.826 52.9327 162.259 38.0304 164.812 42.2354C166.559 45.1126 166.933 43.0679 166.933 43.0679C165.552 39.4636 164.151 37.4875 165.998 34.0438C167.465 31.6382 172.205 26.6399 177.633 25.7677Z",
    fill: "#545454"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.92 11.7881C169.408 11.8524 168.883 11.9811 168.499 12.3027C166.886 13.4092 162.531 17.682 161.315 25.1441C160.022 33.1852 160.508 35.2309 160.508 35.2309L164.963 37.5596C164.963 37.5596 163.83 17.2315 172.932 12.5612C173.06 12.4969 173.543 12.3032 173.415 12.3032L169.933 11.7881H169.92Z",
    fill: "#FDC812"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.064 48.0693C166.064 48.0693 171.556 54.4893 177.226 55.0812",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.005 56.4442L176.394 55.6208C176.112 55.505 175.869 55.1576 175.946 54.8359C176.01 54.4371 176.253 54.2441 176.573 54.2699L179.249 54.7073C179.581 54.733 179.837 55.1576 179.773 55.5564L179.709 56.0325C179.633 56.3541 179.338 56.56 178.993 56.457L179.005 56.4442Z",
    fill: "#545454"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.556 51.3125C158.511 51.4283 155.183 48.1604 155.068 44.1076L155.004 41.007C154.889 36.9414 158.14 33.5963 162.172 33.4805C166.217 33.3647 169.546 36.6326 169.661 40.6854L169.725 43.786C169.789 47.813 166.589 51.1967 162.556 51.3125Z",
    fill: "#FDC812"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.662 45.8479C162.825 46.8643 165.398 45.9122 166.41 43.7379C167.421 41.5636 166.474 38.9776 164.31 37.9612C162.147 36.9448 159.574 37.8969 158.563 40.0712C157.551 42.2455 158.499 44.8315 160.662 45.8479Z",
    fill: "#FFEE89"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5825 122.175L73.8908 138.476H86.1532L88.3412 122.175H71.5945H71.5825Z",
    fill: "#B3DAFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9509 83.1894C76.9083 87.7624 77.9903 93.8797 74.9126 95.943C71.835 98.0062 65.6076 95.1708 62.6501 90.5978C59.6927 86.0249 59.825 80.6797 62.9747 78.6165C66.1245 76.5532 70.9934 78.6165 73.9509 83.1894Z",
    fill: "#E7EEA8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3134 100.396C75.6216 103.943 76.4632 108.709 74.0227 110.314C71.5822 111.919 66.7734 109.735 64.4532 106.188C62.1449 102.64 62.2652 98.4535 64.7056 96.8488C67.1461 95.244 70.9932 96.8488 73.3014 100.396H73.3134Z",
    fill: "#F3F6D1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5776 108.057C88.7142 110.446 85.6967 112.183 84.0256 110.892C82.3545 109.601 82.7393 105.8 84.6027 103.423C86.4661 101.034 89.2913 100.141 90.9623 101.42C92.5613 102.639 92.441 105.607 90.5776 108.057Z",
    fill: "#E7EEA8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.244 76.1678C91.2866 82.2852 86.0931 87.8958 81.9215 85.8325C77.7498 83.7693 76.0788 74.8768 79.0362 68.7594C81.9936 62.642 87.8243 59.3481 92.0079 61.4113C96.2397 63.4143 97.2015 70.0384 94.2561 76.1678H94.244Z",
    fill: "#F3F6D1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9287 125.973H87.0546",
    stroke: "#3E91FF",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4463 128.341H86.5383",
    stroke: "#3E91FF",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4091 123.009C79.4091 123.009 81.008 98.1412 67.2188 84.1689",
    stroke: "#5F6F1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3291 67.6699C88.3291 67.6699 78.1825 90.0882 78.7596 111.022",
    stroke: "#5F6F1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4492 100.396C66.4492 100.396 77.1729 108.323 78.8319 122.174",
    stroke: "#5F6F1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3292 104.002C88.3292 104.002 81.4646 112.436 81.9094 122.233",
    stroke: "#5F6F1C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M343 137.999H0V139.999H343V137.999Z",
    fill: "#DFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerServiceImage);
export default __webpack_public_path__ + "static/media/customer-service-image.8ea98bd7544faab5167e9ad91615d8f6.svg";
export { ForwardRef as ReactComponent };